import { Empty } from '@upzi/web-shell/custom-components/empty';

type JobListEmptyProps = {
  onAdjustSearch: () => void;
};

export function JobListEmpty({ onAdjustSearch }: JobListEmptyProps) {
  return (
    <div className="flex min-h-[510px] items-center justify-center px-5 py-6 sm:min-h-[618px] sm:px-20 sm:pt-10 sm:pb-6">
      <Empty
        className="w-full max-w-[520px] rounded-2xl sm:gap-0"
        title="Không tìm thấy việc làm phù hợp"
        titleAs="h1"
        content="Thử tìm bằng từ khoá khác hoặc bỏ bớt điều kiện lọc nhé"
        cta={{
          type: 'button',
          onClick: onAdjustSearch,
          label: 'Chỉnh tìm kiếm',
          variant: 'outline',
        }}
      />
    </div>
  );
}
